import { BLOCK_REGISTRY } from "../blockRegistry";

const CAREERS_DEFAULT_BLOCKS = [
  {
    id: "default-careers-hero",
    type: "about-hero",
    fields: {
      ...BLOCK_REGISTRY["about-hero"].defaultFields,
      eyebrow: "Careers",
      headline: "Work With Exqura",
      subtext: "Help us create unforgettable golf experiences.",
    },
  },
  {
    id: "default-careers-roles",
    type: "generic-link-cards",
    fields: {
      eyebrow: "Open Roles",
      headline: "No Open Roles Right Now",
      items: [
        { icon: "Mail", title: "Introduce yourself", description: "We don't have any roles listed at the moment, but we'd still love to hear from you.", linkLabel: "Email us", href: "mailto:hello@exqura.com" },
      ],
    },
  },
];

export default CAREERS_DEFAULT_BLOCKS;
